__turbopack_context__.v({
  "activeFilters": "ActiveFilters-module-scss-module__X7wGDW__activeFilters",
  "chip": "ActiveFilters-module-scss-module__X7wGDW__chip",
  "chipLabel": "ActiveFilters-module-scss-module__X7wGDW__chipLabel",
  "chipValue": "ActiveFilters-module-scss-module__X7wGDW__chipValue",
  "chips": "ActiveFilters-module-scss-module__X7wGDW__chips",
  "clearAll": "ActiveFilters-module-scss-module__X7wGDW__clearAll",
  "removeIcon": "ActiveFilters-module-scss-module__X7wGDW__removeIcon",
});
